<h3 mat-dialog-title>{{ (data?.folder ? 'dialog.add_new_pinboard_folder.edit' : 'dialog.add_new_pinboard_folder.add') | translate }}</h3>
<mat-dialog-content>
  <mat-form-field appearance="outline">
    <mat-label>{{ 'dialog.add_new_pinboard_folder.folder_name' | translate }}</mat-label>
    <input type="text" matInput [formControl]="folderName">
    @if (folderName.hasError('duplicate_name')) {
      <mat-error>
        {{ 'dialog.add_new_pinboard_folder.duplicate_name' | translate }}
      </mat-error>
    }
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions class="flex-row justify-between flex-1"Fill>
  <button mat-button color="primary" (click)="onClose()">{{ 'generic.close' | translate }}</button>
  <button mat-button color="primary" (click)="onAdd()">{{ 'generic.add' | translate }}</button>
</mat-dialog-actions>
